import { PaymentHistoryModalForm } from "./PaymentHistoryModalForm"

const PaymentHistoryModalFormWrapper = ({
  selectedBookingId,
  setSelectedBookingId,
  setOpenPaymentHistoryModal,
}) => {

    return (
      <PaymentHistoryModalForm
      selectedBookingId={selectedBookingId}
      setSelectedBookingId={setSelectedBookingId}
      setOpenPaymentHistoryModal={setOpenPaymentHistoryModal}
      />
    );
  }


export { PaymentHistoryModalFormWrapper };
